var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active"},[_c('loading',{attrs:{"active":_vm.$root.isLoading,"is-full-page":true,"loader":_vm.$root.loaderType,"color":_vm.$root.color,"height":125,"width":125},on:{"update:active":function($event){return _vm.$set(_vm.$root, "isLoading", $event)}}}),_c('router-view',{})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }